export enum ClockType {
  MAN = 'man',
  CLK = 'clk'
}
